import { EventProperty } from "./EventProperty";
import { ExpressionProperty } from "./ExpressionProperty";
import { FunctionProperty } from "./FunctionProperty";
import { NodeNameProperty } from "./NodeNameProperty";
import { TriggerTypeProperty } from "./TriggerTypeProperty";
import { ValueProperty } from "./ValueProperty";

const nodeProperties = {
  TriggerType: TriggerTypeProperty,
  Name: NodeNameProperty,
  Value: ValueProperty,
  Function: FunctionProperty,
  Event: EventProperty,
  Expression: ExpressionProperty,
};

export const AdaptiveNodeProperty = ({ propertyType, ...otherProps }) => {
  const PropertyComponent = nodeProperties[propertyType];

  if (!PropertyComponent) {
    return;
  }

  return <PropertyComponent {...otherProps} />;
};
